import { render, staticRenderFns } from "./PaqLaboratorio.vue?vue&type=template&id=6c54dcb4"
import script from "./PaqLaboratorio.vue?vue&type=script&lang=js"
export * from "./PaqLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports